var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTmnWalletLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6F6F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13373_118833)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2327 13.6184C15.129 13.277 14.7682 13 14.4252 13H13.7032H8.46094C8.11822 13 7.92478 13.277 8.02757 13.6184L11.3957 24.8202C11.4987 25.162 11.86 25.4393 12.2027 25.4393H15.7842H17.0997C17.4427 25.4393 17.8277 25.162 17.9609 24.8202L18.3226 23.8899L15.2327 13.6184Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2866 16.3848H18.4889H16.3976C16.0084 16.3848 15.8413 16.6618 15.7206 17.0033L12.9725 24.8186C12.972 24.8199 12.9715 24.8216 12.9712 24.823C12.8482 25.1628 12.4747 25.4374 12.1338 25.4374H15.3057H19.1011C19.4435 25.4374 19.8191 25.1599 19.94 24.8186L22.6881 17.0033C22.8086 16.6618 22.629 16.3848 22.2866 16.3848Z",
    fill: "#9D0B0F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1456 16.9998C23.0421 16.6583 22.6812 16.3813 22.3383 16.3813H21.6162H16.374C16.0314 16.3813 15.8377 16.6583 15.9407 16.9998L18.7387 26.3662C18.8419 26.708 19.2032 26.9851 19.5459 26.9851H23.1275H24.4428C24.7858 26.9851 25.1708 26.708 25.304 26.3662L25.6658 25.4357L23.1456 16.9998Z",
    fill: "#FFCE01"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5759 14.4038H29.163H25.2465C24.9039 14.4038 24.5188 14.6808 24.3853 15.0226L20.3948 26.3664C20.3939 26.3691 20.3928 26.3712 20.3921 26.3739C20.2564 26.7123 19.8749 26.9853 19.5342 26.9853H20.774H24.691H25.7879H27.1033C27.4457 26.9853 27.8314 26.7083 27.9641 26.3664L31.955 15.0226C32.0882 14.6808 31.9182 14.4038 31.5759 14.4038Z",
    fill: "#FF8300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13373_118833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 13.9851,
    fill: "white",
    transform: "translate(8 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmnWalletLogo);
export default __webpack_public_path__ + "static/media/tmn-wallet-logo.a98be1c107822746817002f18722cfe1.svg";
export { ForwardRef as ReactComponent };